import { createFileRoute } from '@tanstack/react-router';
import { ReferrerDetailRoute } from '@/pages/referrers/detail-route';

/** Deep link al dettaglio: la lista sta già sotto, montata dal layout. */
export const Route = createFileRoute('/admin/_layout/referrers/_layout/$id')({
  component: ReferrerDetailRouteComponent,
});

function ReferrerDetailRouteComponent() {
  const { id } = Route.useParams();

  return <ReferrerDetailRoute id={id} />;
}
